/* Vitals alone mutates gift lines. The adapter reads eligibility, refreshes UI,
 * and prevents checkout while gift reconciliation is pending. */
(() => {
  if (window.alpineVitalsCartMounted) return;
  window.alpineVitalsCartMounted = true;
  let giftSignature = null, positionTimer, giftCandidates = [], emptySince = 0, recoveryTimer;
  let root = null, active = null, amount = null, timer, busy = false, queued = false, pending = null, quantityPending = false, giftPending = false, giftPolls = 0;
  document.addEventListener('click', event => {
    const gift=event.target.closest('.vtl-ub-gift-root');
    if(gift && document.querySelector('#CartPageForm') && !document.querySelector('#CartDrawer.drawer--is-open')){
      document.documentElement.dataset.alpineGiftCartPageUntil=String(Date.now()+10000);
    }else if(event.target.closest('.js-drawer-open-cart,form[action*="/cart/add"]')){
      delete document.documentElement.dataset.alpineGiftCartPageUntil;
    }
  },true);
  // Vitals renders option lists in a dialog portal outside the drawer.
  // Let option/document handlers run, but do not bubble into outside-close.
  document.addEventListener('click', event => {
    const portal = (event.composedPath?.() || []).some(node =>
      node?.classList?.contains('Vtl-Dropdown__Portal-List'));
    if (portal && document.querySelector('#CartDrawer.drawer--is-open [data-alpine-vitals-cart] .vtl-ub-gift-root')) {
      event.stopPropagation();
    }
  });
  const mounts = () => Array.from(document.querySelectorAll('[data-alpine-vitals-cart]'));
  const money = n => 'NT$' + (n / 100).toLocaleString('zh-TW', {maximumFractionDigits: 2});
  const isAlpine = node => {
    const links = Array.from(node.querySelectorAll('.vtl-ub-gift__product__title'));
    return links.length && links.every(a => /毛帽頭套|Fingerless|開指|磁吸雪鏡|Ski Goggles/.test(a.textContent));
  };
  function position() {
    const list = mounts();
    const drawer = document.querySelector('#CartDrawer.drawer--is-open');
    const target = (drawer && list.find(m => drawer.contains(m))) || list.find(m => m.closest('#CartPageForm'));
    // Vitals can replace its root while reconciling gifts. Never resurrect
    // a detached React container or let an obsolete empty root win selection.
    document.querySelectorAll('.vtl-ub-gift-root').forEach(node => {
      if (!node.childNodes.length) node.remove();
    });
    const found = Array.from(document.querySelectorAll('.vtl-ub-gift-root')).find(isAlpine);
    root = found || (root?.isConnected ? root : null);
    if (!target || amount === null || amount <= 0) {
      list.forEach(m => { m.hidden = true; });
      if (root?.closest('[data-alpine-vitals-cart]')) document.body.append(root);
      return;
    }
    active = target;
    list.forEach(m => { m.hidden = m !== target; });
    const mount = target.querySelector('[data-alpine-vitals-mount]');
    if (root && root.parentElement !== mount) mount.append(root);
    target.id = target.closest('#CartPageForm') ? 'alpine-gifts' : 'alpine-gifts-drawer';
    const available = amount >= 3500000 ? 3 : amount >= 2000000 ? 1 : 0;
    const claimed = giftCandidates.filter(g => g.final_line_price === 0 && amount >= g.threshold).length;
    const empty = !root?.querySelector('.vtl-ub-gift__product__title');
    // Vitals removes its widget children when all gifts are claimed, while
    // retaining the React root. Retire only an empty container so the next
    // native cart reconciliation mounts into a fresh root in this same slot.
    target.querySelector('[data-alpine-gift-recovery]')?.remove();
    // Open through Vitals so its focus/inert state remains authoritative.
    const trigger = root?.querySelector('.vtl-ub-gift__trigger');
    if (trigger?.getAttribute('aria-expanded') === 'false') trigger.click();
    const status = amount < 2000000 ? '再消費 ' + money(2000000 - amount) + '，解鎖可翻式毛帽頭套。'
      : amount < 3500000 ? '毛帽頭套已解鎖；再消費 ' + money(3500000 - amount) + '，再享手套與雪鏡。'
      : '毛帽頭套、手套與雪鏡，已全部解鎖。';
    const text = target.querySelector('[data-alpine-gift-status]');
    if (text.textContent !== status) text.textContent = status;
    const fill = Math.min(100, amount / 3500000 * 100) + '%';
    const bar = target.querySelector('[data-alpine-gift-fill]');
    if (bar.style.width !== fill) bar.style.width = fill;
    target.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.min(35000, amount / 100));
    root?.querySelectorAll('.vtl-ub-gift__tier').forEach(t => {
      const title = t.querySelector('.vtl-ub-gift__product__title')?.textContent || '';
      t.dataset.alpineThreshold = /毛帽頭套/.test(title) ? 'NT$20,000' : 'NT$35,000';
    });
  }
  async function refresh() {
    if (busy) { queued = true; return pending; }
    const target = mounts()[0];
    if (!target) return;
    busy = true;
    try {
      const response = await fetch(target.dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'});
      const ledger = await response.json();
      giftCandidates = ledger.gift_candidates || [];
      amount = ledger.currency === 'TWD' && Number.isSafeInteger(ledger.eligible_subtotal) ? ledger.eligible_subtotal : null;
      const nextGiftSignature = JSON.stringify((ledger.gift_candidates || []).map(g => [g.key, g.final_line_price]).sort());
      const giftsChanged = giftSignature !== null && giftSignature !== nextGiftSignature;
      giftSignature = nextGiftSignature;
      // Refresh native line markup once when gift lines actually change.
      if (giftsChanged) document.dispatchEvent(new CustomEvent('cart:build')); 
      if (amount !== null) {
        const invalid = (ledger.gift_candidates || []).filter(g => Number.isSafeInteger(g.threshold) && amount < g.threshold);
        // Give Vitals a chance to reconcile first. Some PDPs do not load its
        // widget. Never send expired keys to update.js or fall back to variant IDs.
        if (invalid.length) {
          giftPending = true;
          ++giftPolls;
          // Vitals is the sole gift-removal writer. Parallel change.js requests
          // can race its update.js batch and invalidate same-variant gift keys.
          if (giftPolls <= 20) {
            clearTimeout(timer);
            timer = setTimeout(() => { pending = refresh(); }, 750);
          }
        } else {
          giftPolls = 0;
          if (giftPending) {
            giftPending = false;
            // The changed gift signature above already schedules one rebuild.
          }
        }
      }
      position();
    } catch (_) { amount = null; position(); }
    finally { busy = false; if (queued) { queued = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(() => { pending = refresh(); }, 350); }
  new MutationObserver(records => {
    if (records.some(r => r.type === 'childList')) {
      clearTimeout(positionTimer);
      positionTimer = setTimeout(position, 80);
    }
  }).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('cart:updated', () => { quantityPending = false; });
  document.addEventListener('click', e => { if (e.target.closest('.js-qty__adjust')) quantityPending = true; }, true);
  document.addEventListener('change', e => { if (e.target.matches('.js-qty__num')) quantityPending = true; }, true);
  ['cart:updated','cart:build','ajaxProduct:added','drawerOpen'].forEach(name => document.addEventListener(name, schedule));
  document.addEventListener('click', e => {
    if (e.target.closest('.js-qty__adjust,.vtl-ub-gift-root,.js-drawer-open-cart,.js-drawer-close')) {
      schedule(); setTimeout(() => { pending = refresh(); }, 1200); setTimeout(() => { pending = refresh(); }, 2500);
    }
  });
  document.addEventListener('change', e => { if (e.target.closest('#CartDrawerForm,#CartPageForm')) schedule(); });
  let checkoutChecked = false;
  document.addEventListener('submit', async e => {
    if (checkoutChecked || !e.target.matches('#CartDrawerForm,#CartPageForm')) return;
    const button = e.submitter;
    if (!button || button.name !== 'checkout') return;
    e.preventDefault(); e.stopImmediatePropagation();
    button.disabled = true;
    try {
      if (quantityPending) throw new Error('Quantity update pending');
      if (pending) await pending;
      await refresh();
      // Re-read after removals; never submit a cart with a charged promotional gift.
      const response = await fetch(mounts()[0].dataset.ledgerUrl, {credentials:'same-origin',cache:'no-store'});
      const ledger = await response.json();
      if ((ledger.gift_candidates || []).length && (ledger.currency !== 'TWD' || !Number.isSafeInteger(ledger.eligible_subtotal) || ledger.gift_candidates.some(g => ledger.eligible_subtotal < g.threshold || g.final_line_price > 0))) throw new Error('Please retry');
      checkoutChecked = true;
      button.disabled = false;
      e.target.requestSubmit(button);
    } catch (_) {
      const status = document.querySelector('[data-alpine-gift-status]');
      if (status) status.textContent = '購物車優惠更新中，請稍後再結帳。';
      button.disabled = false;
    }
  }, true);
  pending = refresh();
})();



